import React from 'react';
import { View, Row, Col } from '../View';
import Logo from "../Logo";
import Nav from "../Nav";
import {MAIN, ROUTES} from '../../constants/navigation'
import { styleUtils } from '../../utils';
import styles from './styles';
import {Link} from "react-router-dom";

const { style } = styleUtils;
const RootContainer = style(View, styles.rootContainer);
const RowContainer = style(Row, styles.rowContainer);
const MainNavigation = style(Nav, styles.nav);


const Topbar = () => (
  <RootContainer>
    <RowContainer type="flex" justify="space-between">
      <Col >
        <h1>
          <Link to={ROUTES.ROOT}><Logo span={4} /></Link>
        </h1>
      </Col>
      <MainNavigation items={MAIN} />
    </RowContainer>
  </RootContainer>
);

export default Topbar;
